<div nz-col class="bg-white px-4 rounded-xl shadow-sm">
  <div nz-col>
    <div nz-row style="padding: 10px" nzJustify="space-between">
      <div nz-col nzFlex="auto">
        <div nz-row [nzGutter]="[16, 16]" [formGroup]="searchForm">
          <div nz-col>
            <nz-range-picker
              [nzRanges]="ranges"
              [(ngModel)]="date"
              [ngModelOptions]="{ standalone: true }"
              nz-col
              nzFlex="0 1 300px"
              [nzFormat]="dateFormat"
              [nzPlaceHolder]="[
                'recordings.start' | translate,
                'recordings.finish' | translate
              ]"
              (ngModelChange)="changeCalendar($event)"
              nzSize="small"
            ></nz-range-picker>
          </div>
          <div nz-col nzFlex="220px">
            <!-- beaut-336: visit-status filter for visit-booking branches, else legacy booking-status -->
            @if (visitBookingEnabled()) {
              <beautyapp-select-search
                formControlName="visitStatus"
                [data]="visitStatuses"
                placeholder="{{'statistic.consignation.search.status' | translate}}"
                valueMember="value"
                displayMember="label"
              ></beautyapp-select-search>
            } @else {
              <beautyapp-select-search
                formControlName="status"
                [data]="statuses"
                placeholder="{{'statistic.consignation.search.status' | translate}}"
                valueMember="value"
                displayMember="label"
              ></beautyapp-select-search>
            }
          </div>
          <div nz-col [nzSpan]="4" *ngxPermissionsExcept="['Employee']">
            <beautyapp-select
              formControlName="employeeId"
              [data]="employees()"
              placeholder="{{
                  'statistic.operation.search.employee' | translate
                }}"
              valueMember="id"
              displayMember="fullName"
            ></beautyapp-select>
          </div>
          <div nz-col [nzSpan]="4">
            <beautyapp-select
              formControlName="createdById"
              [data]="employees()"
              placeholder="{{
                  'statistic.operation.search.createdBy' | translate
                }}"
              valueMember="userId"
              displayMember="fullName"
            ></beautyapp-select>
          </div>
          <div nz-col nzFlex="220px">
            <beautyapp-select-search
              formControlName="userId"
              [data]="customers()"
              placeholder="{{'statistic.consignation.search.user' | translate}}"
              (onSearch)="searchCustomer($event)"
              valueMember="id"
              displayMember="fullName"
            ></beautyapp-select-search>
          </div>
          <div nz-col [nzSpan]="4">
            <beautyapp-select
              formControlName="categoryId"
              placeholder="{{'statistic.detailSearch.search.category' | translate}}"
              valueMember="id"
              displayMember="name"
              [data]="categories()"
            ></beautyapp-select>
          </div>
          <div nz-col [nzSpan]="4">
            <beautyapp-select
              formControlName="serviceId"
              placeholder="{{'statistic.detailSearch.search.procedure' | translate}}"
              valueMember="id"
              displayMember="name"
              [data]="services()"
            ></beautyapp-select>
          </div>
          <div nz-col [nzSpan]="4">
            <beautyapp-select
              formControlName="roomId"
              placeholder="{{'statistic.detailSearch.search.room' | translate}}"
              valueMember="id"
              displayMember="name"
              [data]="rooms()"
            ></beautyapp-select>
          </div>
          <div nz-col [nzSpan]="4">
            <beautyapp-select
              formControlName="sourceId"
              placeholder="{{'statistic.detailSearch.search.source' | translate}}"
              valueMember="id"
              displayMember="name"
              [data]="bookingSources()"
            ></beautyapp-select>
          </div>
          <div nz-col>
            <label nz-checkbox formControlName="isDeleted">{{
                'recordings.deleted' | translate
              }}</label>
          </div>
        </div>
      </div>
      <div nz-col nzFlex="initial">
        <button
          *ngxPermissionsOnly="['Admin', 'Manager']"
          nz-button
          nzType="default"
          nzShape="circle"
          nz-tooltip
          nzTooltipTitle="{{ 'recordings.download' | translate }}"
          (click)="export()"
        >
          <i nz-icon nzType="file-excel" nzTheme="outline"></i>
        </button>
      </div>
    </div>

    <div nz-col class="body-content">
      <nz-table
        nzBordered
        nzShowSizeChanger
        [nzData]="loadData()"
        [nzFrontPagination]="false"
        [nzLoading]="loading()"
        [nzTotal]="total()"
        [nzPageSize]="paginatorPageSize()"
        [nzPageIndex]="paginatorPageIndex()"
        [nzVirtualForTrackBy]="trackByIndex"
        (nzQueryParams)="paginatorChange($event)"
        [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
        nzTableLayout="auto"
        [nzScroll]="{ x: '84vw' }"
        nzSize="small"
      >
        <thead>
        <tr>
          <th nzWidth="180px">{{ 'recordings.status' | translate }}</th>
          <th nzWidth="180px" nzColumnKey="bookingDate" [nzSortFn]="true" nzSortOrder="descend">
            {{ 'recordings.reservationTime' | translate }}
          </th>
          <th nzWidth="100px">{{ 'recordings.startingTime' | translate }}</th>
          <th nzWidth="100px">
            {{ 'recordings.finishingTime' | translate }}
          </th>
          <th nzWidth="200px">{{ 'recordings.user' | translate }}</th>
          <th nzWidth="200px">{{ 'recordings.mobilePhone' | translate }}</th>
          <th nzWidth="200px">{{ 'recordings.service' | translate }}</th>
          <th nzWidth="200px">{{ 'recordings.employee' | translate }}</th>
          <th nzWidth="150px">{{ 'recordings.room' | translate }}</th>
          <th nzWidth="150px">{{ 'recordings.source' | translate }}</th>
          <th nzWidth="120px">{{ 'recordings.price' | translate }}</th>
          <th nzWidth="200px">{{ 'recordings.createdBy' | translate }}</th>
          <th nzWidth="200px">{{ 'recordings.created' | translate }}</th>
          <th nzWidth="180px">
            {{ 'recordings.cancellationDate' | translate }}
          </th>
          <th nzWidth="200px">{{ 'recordings.cancelledBy' | translate }}</th>
          <th nzWidth="200px">
            {{ 'recordings.cancellationReason' | translate }}
          </th>
          <th nzWidth="40px" nzRight></th>
        </tr>
        </thead>
        <tbody>
          @for (row of loadData(); track row; let i = $index) {
            <tr>
              <td>
                <nz-space nzAlign="center" nzSize="small">
                  @if (row?.deletedAt) {
                    <nz-icon nzType="close-circle" nzTheme="twotone"
                             nzTwotoneColor="#ff4d4f"
                             nz-tooltip
                             nzTooltipTitle="{{ 'recordings.deleted' | translate }}"></nz-icon>
                  }
                  <!-- beaut-336: show visit status when the branch uses the visit-booking flow, else legacy booking status -->
                  @if (visitBookingEnabled() && row?.visit?.status) {
                    <nz-tag [nzColor]="visitStatusColor(row?.visit?.status)">
                      {{ row?.visit?.status | visitStatus }}
                    </nz-tag>
                  } @else {
                    @if (row?.status === 1) {
                      <nz-tag nzColor="processing">
                        დაჯავშნილი
                      </nz-tag>
                    }
                    @if (row?.status === 2) {
                      <nz-tag nzColor="success">
                        დასრულებული
                      </nz-tag>
                    }
                  }
                </nz-space>
              </td>
              <td>{{ row?.bookingDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ row?.startTime }}</td>
              <td>{{ row?.endTime }}</td>
              <td>{{ row?.user?.firstname }} {{ row?.user?.lastname }}</td>
              <td>{{ row?.user?.mobilePhone }}</td>
              <td nzEllipsis [nz-tooltip]="row?.service?.name">
                {{ row?.service?.name }}
              </td>
              <td>
                {{ row?.employee?.user?.firstname }}
                {{ row?.employee?.user?.lastname }}
              </td>
              <td>{{ row?.room?.name }}</td>
              <td>
                @if (row?.visit?.source) {
                  <div class="flex items-center gap-2">
                    @if (isEmoji(row?.visit?.source?.icon)) {
                      <span>{{ row?.visit?.source?.icon }}</span>
                    } @else if (row?.visit?.source?.icon) {
                      <span nz-icon [nzType]="row?.visit?.source?.icon" nzTheme="outline"></span>
                    }
                    <span>{{ row?.visit?.source?.name }}</span>
                  </div>
                }
              </td>
              <td>{{ row?.price }}</td>
              <td>
                {{ row?.createdBy?.firstname }} {{ row?.createdBy?.lastname }}
              </td>
              <td>{{ row?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ row?.deletedAt | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>
                {{ row?.deletedBy?.firstname }} {{ row?.deletedBy?.lastname }}
              </td>
              <td>{{ row?.disableReason }}</td>
              <td nzWidth="40px" nzRight>
                @if (!row?.deletedAt) {
                  <button
                    nz-button
                    nzType="default"
                    nzShape="circle"
                    nz-tooltip
                    nzTooltipTitle="{{ 'recordings.download' | translate }}"
                    (click)="handleEventClick(row)"
                  >
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
